import Icon from '../components/Icon.vue'

Icon.register({
  'teeth-open': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 0c53 0 96 43 96 96v64c0 35.3-28.7 64-64 64h-512c-35.3 0-64-28.7-64-64v-64c0-53 43-96 96-96h448zM160 176v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16zM304 176v-56c0-30.9-25.1-56-56-56s-56 25.1-56 56v56c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16zM448 176v-56c0-30.9-25.1-56-56-56s-56 25.1-56 56v56c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16zM576 176v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16zM576 320c35.3 0 64 28.7 64 64v32c0 53-43 96-96 96h-448c-53 0-96-43-96-96v-32c0-35.3 28.7-64 64-64h512zM160 400v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v32c0 26.5 21.5 48 48 48s48-21.5 48-48zM304 392v-24c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v24c0 30.9 25.1 56 56 56s56-25.1 56-56zM448 392v-24c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v24c0 30.9 25.1 56 56 56s56-25.1 56-56zM576 400v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v32c0 26.5 21.5 48 48 48s48-21.5 48-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/teeth-open.js
// module id = 1986
// module chunks = 0